// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';

import { useAuthContext } from 'src/auth/hooks';
import ProgressBar from 'src/components/progress-bar/progress-bar';
import { LinearProgress } from '@mui/material';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const { user } = useAuthContext();
  const { t } = useLocales();
  console.log("user----------------------")
  console.log("user----", user)
  const totalMinutes = user?.subscription.plan.monthly_minutes ?? 15;
  const remainingMinutes = user?.subscription.plan.minutes_left ?? 0;
  const progress = totalMinutes > 0 ? (remainingMinutes / totalMinutes) * 100 : 0;
  const currentPlan = user?.subscription?.plan?.name ?? 'Free';

  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }}>
          <Avatar src={user?.photoURL} alt={user?.displayName} sx={{ width: 48, height: 48 }} />
          <Label
            color="success"
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: 'absolute',
              borderBottomLeftRadius: 2,
            }}
          >
            {currentPlan}
          </Label>
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.displayName}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>

          <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
            <LinearProgress variant="determinate" value={progress} />
            <Typography variant="caption" sx={{ mt: 0.5, display: 'block' }}>
              {t('minutes_left')}: {remainingMinutes} {t('minutes')}
            </Typography>
          </Box>
        </Stack>

        {currentPlan === "Free" ? (
          <Button variant="contained" href={paths.dashboard.account.billing} rel="noopener">
            {t('upgrade_to_pro')}
          </Button>
        ) : (
          <Button variant="outlined" href={paths.dashboard.account.billing} rel="noopener">
            {t('manage_subscription')}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
